export default function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [key, val] = cookies[i].split("=");
    if (key === name) return val;
  }
  return null;
};